import { Typography } from "antd";
import {
  NODE_COLORS,
  NODE_LABELS,
  NODE_LEGEND_ORDER,
} from "./CompanyTree.default";

/**
 * The key to the tree. The graph draws five node types as one shape in five colours, which is the part
 * an operator cannot infer — a grey box and a blue box look identical. The count badge is deliberately
 * NOT explained here: "+4" on a collapsed node reads for itself, and spelling it out cost more panel
 * than it was worth.
 *
 * Colours and labels come from CompanyTree.default so the key cannot drift from what is drawn.
 */
function CompanyTreeLegend() {
  // Width pinned to the filter form's own `w-72` so the key can never set the column's intrinsic width
  // and stretch the filter panel — which is exactly what a long line in here did on the first pass.
  return (
    <div className="flex w-72 flex-col gap-1 pb-2 pt-2">
      <Typography.Text type="secondary" className="text-xs font-semibold">
        LEGEND
      </Typography.Text>
      {NODE_LEGEND_ORDER.map((nodeType) => (
        <div key={nodeType} className="flex flex-row items-center gap-2">
          <span
            className="inline-block h-3.5 w-3.5 shrink-0 rounded-sm"
            style={{ backgroundColor: NODE_COLORS[nodeType] }}
            aria-hidden
          />
          {/* `text-sm` matches the filter labels directly above, so the key reads as part of the same
              panel rather than as fine print under it. The swatch grows with the text to stay square
              against the cap height. */}
          <Typography.Text className="text-sm">
            {NODE_LABELS[nodeType]}
          </Typography.Text>
        </div>
      ))}
    </div>
  );
}

export default CompanyTreeLegend;
